export const storageLocal = {
  get: function (elements) {
    return new Promise((resolve, reject) => {
      let data = elements.map(element => {
        let item = localStorage.getItem(element)
        if (!item || item === undefined) {
          return null
        } else {
          return item
        }
      })
      if (data) {
        resolve(data)
      } else {
        reject(data)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/localstorage.js